const JOB_STATUS = {
  active: 'active',
  cancelled: 'cancelled',
  completed: 'completed',
  open: 'open',
};

const JOB_CATEGORY = {
  dayJob: 'dayJob',
  shift: 'shift',
  longTermJob: 'longTermJob',
};

module.exports = {
  JOB_STATUS,
  JOB_CATEGORY,
};
